<div class="container">
    <div>
        <form #checkout="ngForm" (ngSubmit)="onSubmit(checkout)" class="checkout">
            <div class="form-row" >
                <div class="col-12" id="card-info" #cardInfo></div>
            </div>
            <!-- <div class="form-row" >
                <div class="col-12" id="card-info" #cardInfo></div>
                <div class="col-12" id="card-info" #cardExpiry></div>
                <div class="col-12" id="card-info" #cardCvv></div>
            
            </div> -->
            <br>
            <div class="col-12" id="card-errors" role="alert" *ngIf="error">{{ error }}</div>
            <!-- <div class="col-12" id="card-errors" role="alert" *ngIf="errors">{{ errors }}</div> -->
            <div class="col-6 d-flex justify-content-center"
                style="padding-top: 10px; padding-bottom: 10px;margin: 0 auto;">
                <button class="placeorder-btn" (click)="placePaymentOrders()">Pay now</button>
            </div>
        </form>
    </div>
</div>
<style>
    ::ng-deep .mat-bottom-sheet-container {
        padding: 8px 16px;
        min-width: 100vw;
        box-sizing: border-box;
        display: block;
        outline: 0;
        overflow: auto;
        border-top-left-radius: 16px !important;
        border-top-right-radius: 16px !important;
    }

    ::ng-deep.mat-bottom-sheet-container-large {
        min-width: 380px !important;
        max-width: 380px;
    }

    ::ng-deep.mat-bottom-sheet-container-xlarge {
        min-width: 380px !important;
        max-width: 380px;
    }

    .container {
        position: relative;
        margin-left: auto;
        margin-right: auto;
        padding-right: 11px;
        padding-left: 11px;
        padding-top: 10px;
    }
    .placeorder-btn {
    border: none;
    height: 40px;
    width: 158px;
    border-radius: 19px;
    background:  linear-gradient(266deg, #62AF55 0%, #4AB07F 100%);
    font-size: 18px;
    color: white;
    letter-spacing: 0.9px;
    font-weight: 600;
}
#card-errors{
  /* color: rgb(165, 76, 43) !important;
   */
   color: red;
  padding-top: 25px !important;
  display: flex;
  justify-content: center;
}
#card-info {
  /* max-width: 350px; */
  /* margin-top: -35px !important; */
  text-align: center;
  border: 2px solid #eee;
  border-radius: 8px;
  padding: 1rem 2rem;
  background: gainsboro;
  font-family: "Helvetica Neue", Helvetica, sans-serif;
  color: #525252;
  font-size: 1.1rem;
  /* margin: 0px 0px 0px 9px; */
}
</style>